import React from 'react';
import PlayerSpeedControls from '../../containers/PlayerSpeedControls';
import PlayerOptions from '../../containers/PlayerOptions';
import DistanceText from '../distanceText/DistanceText';
import SpeedText from '../speedText/SpeedText';
import SharingControl from '../sharingControl/SharingControl';
import Fullscreen from '../../containers/PlayerFullscreen';
import TerrainProfile from '../terrainProfile/TerrainProfileCanvas';
import TimeSlider from '../../containers/TimeSlider';
import TrackSelectorButton from '../../containers/TrackSelectorButton';
import style from './playerControls.css';
const kMobileControlsTimeout = 3000;
const TerrainProfileHolder = ({ hideElements }) => {
    if (hideElements.includes('terrainProfile'))
        return null;
    return React.createElement(TerrainProfile, null);
};
class MobileControls extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timeout: undefined,
        };
    }
    resetHideTimer() {
        // Hide the controls after X seconds of nothing being clicked
        clearTimeout(this.state.timeout);
        this.state.timeout = setTimeout(() => {
            if (this.props.showControls)
                this.props.toggleControls();
        }, kMobileControlsTimeout);
    }
    render() {
        const { isMobile, showControls, hideElements } = this.props;
        if (!isMobile)
            return null;
        if (showControls)
            this.resetHideTimer();
        return (React.createElement("div", { className: `${style.mobileControls} ${showControls ? '' : style.hidden}`, onClick: () => this.resetHideTimer() },
            React.createElement(PlayerOptions, null),
            React.createElement(PlayerSpeedControls, null),
            hideElements.includes('sharing') ? (React.createElement("div", { className: style.filler })) : (React.createElement(SharingControl, { parent: 'footer', isMobile: isMobile }))));
    }
}
const ControlBarMobile = () => (React.createElement("div", { className: `${style.controlBar} controlBar padIphoneX` },
    React.createElement(SpeedText, null),
    React.createElement(DistanceText, null)));
const ControlBarDesktop = ({ rootElement, miniUi, hideElements }) => (React.createElement("div", { className: `${style.controlBar} controlBar ${hideElements.includes('terrainProfile') ? style.dark : ''}` },
    React.createElement("div", { className: style.buttonHolderLeft },
        React.createElement(PlayerSpeedControls, null),
        React.createElement("span", { className: style.spacer }),
        React.createElement(SpeedText, null)),
    miniUi && React.createElement(TimeSlider, null),
    React.createElement("div", { className: style.buttonHolderRight },
        React.createElement(DistanceText, null),
        React.createElement("span", { className: style.spacerHalf }),
        miniUi && React.createElement(TrackSelectorButton, null),
        React.createElement(PlayerOptions, null),
        hideElements.includes('sharing') ? null : React.createElement(SharingControl, { parent: 'footer', isMobile: false }),
        React.createElement(Fullscreen, { rootElement: rootElement }))));
const ControlBar = ({ rootElement, isMobile, miniUi, hideElements }) => {
    if (hideElements.includes('controlBar')) {
        return null;
    }
    else {
        return isMobile ? (React.createElement(ControlBarMobile, null)) : (React.createElement(ControlBarDesktop, { miniUi: miniUi, hideElements: hideElements, rootElement: rootElement }));
    }
};
const PlayerControls = props => {
    // Hide the TerrainProfile while MiniUI mode is active
    const hideElements = props.miniUi ? props.hideElements.concat(['terrainProfile']) : props.hideElements;
    return (React.createElement("div", { className: style.playerControls },
        React.createElement(MobileControls, { isMobile: props.isMobile, showControls: props.showControls, hideElements: hideElements, toggleControls: props.toggleControls }),
        React.createElement("div", { className: `${style.slideIn} ${props.isMobile ? 'isMobile' : 'isDesktop'}` },
            React.createElement(TerrainProfileHolder, { hideElements: hideElements }),
            React.createElement(ControlBar, { hideElements: hideElements, isMobile: props.isMobile, miniUi: props.miniUi, rootElement: props.rootElement }))));
};
export default PlayerControls;
